Drupal.behaviors.accordion = {
  attach() {
    var accItem = document.querySelectorAll('.tab');
    var accHD = document.querySelectorAll('.tab .ac-title');
    for (i = 0; i < accHD.length; i++) {
        accHD[i].addEventListener('click', toggleItem, false);
    }
    function toggleItem(event) {
      event.preventDefault();
        var itemClass = this.parentNode.className;
        for (i = 0; i < accItem.length; i++) {
            accItem[i].className = 'tab close';
        }
        this.parentNode.className = 'tab open';
        if (itemClass == 'tab open') {
          this.parentNode.className = 'tab close';
        }
    }

    jQuery('.tab .ac-title').on('click',function(){
      if(jQuery(this).closest('.tab').hasClass('open')){
        jQuery(this).find('.ac-accessibilty-txt').text('click to close accordion');
      }
      else {
        jQuery(this).find('.ac-accessibilty-txt').text('click to open accordion');
      }
    });

  },
};

